/***********
 *Bootstrap*
 ***********/

import { listenColorSchemeChanges, updateFaviconByScheme } from './utils/helpers';
import { arrayFrom, debounce, fadeOut } from './utils/helpers';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";

(function() {
	try {
		if (top.location.hostname != self.location.hostname) {
			throw 1;
		}
	} catch (e) {
		document.body.style.display = 'none';
	}

	window.optimizelyEvents = [];

	if (OPTIMIZELY_SDK_KEY) {
		window.optimizelyClientInstance = window.optimizelySdk.createInstance({
			sdkKey: OPTIMIZELY_SDK_KEY
		});

		window.optimizelyClientInstance.onReady().then(() => {
			try {
				// optimizelyClientInstance is ready to use, with datafile downloaded from the Optimizely CDN
				const events = JSON.parse(window.optimizelyClientInstance.projectConfigManager.datafileManager.currentDatafile).events;

				window.optimizelyEvents = events.map((event) => event.key);
			} catch (e) {
				window.console.log('Optimizely events could not be defined');
			}
		});
	}

	// Pass debounce and fadeOut functions to window to be used in glo-scripts.html
	window.debounce = debounce;
	window.fadeOut = fadeOut;

	window.isTouch = function() {
		var msTouchEnabled = window.navigator.msMaxTouchPoints,
			generalTouchEnabled = 'ontouchstart' in document.createElement('div');

		return msTouchEnabled || generalTouchEnabled;
	};

	window.isMobileOrTablet = function() {
		var isMobileOrTablet = false;

		/* eslint-disable-next-line */
		(function(a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) isMobileOrTablet = true; })(navigator.userAgent || navigator.vendor || window.opera);
		return isMobileOrTablet;
	};

	// Enable CSS animations after page has loaded
	document.body.classList.remove('preload');

	var bodyClass = window.isTouch() ? 'body--touch-device' : 'body--not-touch-device';

	document.body.classList.add(bodyClass);

	var initGDPR = function() {
		// If in EU, append cookie banner before </body>
		if (document.cookie.indexOf('isEU=true') > -1) {
			// Check to see if user has already dismissed the banner
			if (document.cookie.indexOf('showCookieBanner=true') > -1) {
				var cookieBannerEl = document.createElement('div');
				cookieBannerEl.className = 'cookie-banner';

				if (typeof window.zE === 'function') {
					window.zE('webWidget:on', 'chat:status', function(status) {
						if (status == 'online') {
							cookieBannerEl.classList.add('cookie-banner--zendesk-active');
						}
					});
				}

				cookieBannerEl.innerHTML = '\
					<span>This website uses cookies and analytics to enhance your user experience. \
					Please review our <a href="/privacy" class="f-link" target="_blank">privacy policy</a> to learn \
					more. By continuing to use our site, you are agreeing to our privacy policy.</span>\
					<div class="modal__close-button"></div>\
				';

				document.body.appendChild(cookieBannerEl);

				// Bind click function to allow user to close the banner

				arrayFrom(document.querySelectorAll('.cookie-banner .modal__close-button')).forEach(function(closeButtonEl) {
					closeButtonEl.addEventListener('click', function() {
						var onboardingMobileNav = document.querySelectorAll('.onboarding__custom-nav');

						// Save the fact that the user closed the banner to a cookie
						document.cookie = 'showCookieBanner=false';
						cookieBannerEl.parentNode.removeChild(cookieBannerEl);

						// This is specifically for the mobile nav on /register
						// There is also logic that live in carousel.js in the yogaglo-web repo
						if (onboardingMobileNav) {
							var valuePropsContainer = document.querySelector('.onboarding__value-props-container');
							var valuePropsContinueBtn = document.querySelector('.onboarding-carousel__continue-value-props');

							if (valuePropsContainer) {
								valuePropsContainer.style.marginBottom = '';
								valuePropsContinueBtn.style.bottom = '';
							}

							onboardingMobileNav.forEach(function(element) {
								element.style.marginBottom = '0';
							});
						}
					});
				});
			}

			arrayFrom(document.querySelectorAll('.class__shared-complete-email')).forEach(function(element) {
				element.parentNode.removeChild(element);
			});

			arrayFrom(document.querySelectorAll('.class__shared-complete .alert--error')).forEach(function(element) {
				element.parentNode.removeChild(element);
			});
		} else {
			arrayFrom(document.querySelectorAll('.register-form__opt-in-marketing')).forEach(function(element) {
				element.parentNode.removeChild(element);
			});
		}
	};

	// If isEU cookie has not been set, make request to get location
	if (document.cookie.indexOf('isEU') === -1) {
		fetch(`${API_URL}/location`, { method: 'POST' })
			.then((response) => {
				if (!response.ok) throw Error('Issue getting user\'s location');
				return response.json();
			})
			.then((responseJSON) => {
				document.cookie = 'isEU=' + responseJSON.location.isEU;
				document.cookie = 'showCookieBanner=' + responseJSON.location.isEU;

				initGDPR();
			})
			.catch((error) => {
				window.console.log(error);
			});
	} else {
		initGDPR();
	}

	function handleFirstTab(e) {
		if (e.keyCode === 9) {
			document.body.classList.add('user-is-tabbing');

			window.removeEventListener('keydown', handleFirstTab);
			window.addEventListener('mousedown', handleMouseDownOnce);
		}
	}

	function handleMouseDownOnce() {
		document.body.classList.remove('user-is-tabbing');

		window.removeEventListener('mousedown', handleMouseDownOnce);
		window.addEventListener('keydown', handleFirstTab);
	}

	window.addEventListener('keydown', handleFirstTab);

	// Set favicon by system color scheme
	document.addEventListener('DOMContentLoaded', () => {
		updateFaviconByScheme();
		listenColorSchemeChanges();
	});

	window.getFormattedTimestamp = function(timecode, alwaysShowHours) {
		var d = Number(timecode);
		var h = Math.floor(d / 3600);
		var m = Math.floor(d % 3600 / 60);
		var s = Math.floor(d % 3600 % 60);
		var formattedHour = '';

		// Extra fallback in case h/m/s comes back as a negative number
		if (h < 0) h = 0;
		if (m < 0) m = 0;
		if (s < 0) s = 0;

		if (alwaysShowHours || (!alwaysShowHours && h > 0)) {
			formattedHour = (h < 10 ? '0' : '') + h + ':';
		}

		return formattedHour + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
	};

	const firebaseConfig = {
		apiKey: "AIzaSyC2XPLAtrAolF52Zkd97O631MJOqVAWhLI",
		authDomain: "glofirebase.firebaseapp.com",
		projectId: "glofirebase",
		storageBucket: "glofirebase.appspot.com",
		messagingSenderId: "1002620185452",
		appId: "1:1002620185452:web:fa0be3c28b3999a8aaa149",
		measurementId: "G-H20FRTLCP3"
	};

	// Initialize Firebase
	const app = initializeApp(firebaseConfig);
	getAnalytics(app);
})();
